/** Minimal JobPosting jobLocation when we have location text but no resolvable ISO country. */
export const FINLAND_COUNTRY_ONLY_JOB_LOCATION_PLACE = {
  '@type': 'Place',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'FI',
  },
} as const;

export function buildFinlandCountryOnlyJobLocationPlace(): Record<string, unknown> {
  return {
    '@type': FINLAND_COUNTRY_ONLY_JOB_LOCATION_PLACE['@type'],
    address: { ...FINLAND_COUNTRY_ONLY_JOB_LOCATION_PLACE.address },
  };
}
